import React, { useState } from "react";
import logo from "../../media/Logo-2024.png";
import { menuItems } from "./menuItems";
import NavItem from "./NavItem";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function Menu() {
  const [open, setOpen] = useState(false);

  return (
    <header className=" flex flex-row justify-between lg:justify-evenly w-screen fixed z-50 top-0 left-0 items-center bg-white/80 backdrop-blur-lg py-1 shadow-lg px-4 lg:px-0">
      {/* LOGO */}
      <span className="group">
        <Link to="/" className="flex flex-row gap-2 items-center ">
          <img
            src={logo}
            width={128}
            height={128}
            alt="Brighton Centro de Inglés"
            className="w-12 sm:w-14 lg:w-14 xl:w-16 p-2"
          />
          <h1 className=" font-bold text-primario group-hover:text-yellow-1 transition-all duration-200 ease-in-out text-sm sm:text-base lg:text-sm">
            Brighton Centro de Inglés
          </h1>
        </Link>
      </span>

      {/* DESKTOP NAV (SIN CAMBIOS) */}
      <nav className="hidden lg:block transition-colors duration-500 ease-in-out">
        <div className="flex flex-row gap-20 xl:gap-0 justify-between items-center mx-auto transition-colors duration-500 ease-in-out lg:text-sm xl:text-base">
          <ul className="flex flex-row gap-4 items-center">
            {menuItems.map((item) => (
              <NavItem key={item.name} item={item} />
            ))}
          </ul>
        </div>
      </nav>

      {/* BOTONES DESKTOP */}
      <span className="hidden lg:flex flex-row gap-1 items-center">
        <a
          className="bg-primario text-white font-bold px-5 py-2 rounded-lg rounded-tl-none"
          href="https://sistema.brightonenglishcenter.edu.co/#/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Consulta tus Notas
        </a>
        <Link
          to={"/nosotros/contactanos"}
          className="bg-yellow-1 text-primario font-bold px-5 py-2 rounded-lg rounded-tl-none"
        >
          Contáctanos
        </Link>
      </span>

      {/* BOTÓN HAMBURGUESA */}
      <button
        onClick={() => setOpen(!open)}
        className="lg:hidden flex items-center justify-center  text-primario"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="icon icon-tabler icons-tabler-filled icon-tabler-menu-2"
        >
          {open ? (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="icon icon-tabler icons-tabler-filled icon-tabler-x"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M6.707 5.293l5.293 5.292l5.293 -5.292a1 1 0 0 1 1.414 1.414l-5.292 5.293l5.292 5.293a1 1 0 0 1 -1.414 1.414l-5.293 -5.292l-5.293 5.292a1 1 0 1 1 -1.414 -1.414l5.292 -5.293l-5.292 -5.293a1 1 0 0 1 1.414 -1.414" />
              </svg>
            </>
          ) : (
            <>
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M21 6a1 1 0 0 1 -1 1h-16a1 1 0 1 1 0 -2h16a1 1 0 0 1 1 1" />
              <path d="M21 12a1 1 0 0 1 -1 1h-16a1 1 0 0 1 0 -2h16a1 1 0 0 1 1 1" />
              <path d="M21 18a1 1 0 0 1 -1 1h-16a1 1 0 0 1 0 -2h16a1 1 0 0 1 1 1" />
            </>
          )}
        </svg>
      </button>

      {/* MENÚ MÓVIL / TABLET */}
      {open && (
        <div className="absolute top-full left-0 w-full min-h-screen bg-white shadow-lg lg:hidden flex flex-col p-4 gap-4 animate-fadeIn">
          {/* ITEMS CON ACCORDION */}
          <ul className="flex flex-col gap-2">
            {menuItems.map((item, index) => (
              <details key={index} name={item.name} className="group">
                <summary>{item.name}</summary>
                <ul className="flex flex-col gap-2 mt-2 pl-4">
                  {item.subItems &&
                    item.subItems.map((subItem) => (
                      <Link
                        key={subItem.id}
                        to={subItem.link}
                        className={`hover:text-yellow-1`}
                        onClick={() => setOpen(!open)}
                      >
                        {subItem.name}
                      </Link>
                    ))}
                </ul>
              </details>
            ))}
          </ul>

          {/* BOTONES MOBILE */}
          <div className="flex flex-col gap-3 mt-2">
            <a
              className="bg-primario text-white font-bold px-5 py-2 rounded-lg rounded-tl-none text-center"
              href="https://sistema.brightonenglishcenter.edu.co/#/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Consulta tus Notas
            </a>

            <Link
              to={"/nosotros/contactanos"}
              className="bg-yellow-1 text-primario font-bold px-5 py-2 rounded-lg rounded-tl-none text-center"
              onClick={() => setOpen(false)}
            >
              Contáctanos
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}

export default Menu;
